import actions from './actions';

const { setPortfolios } = actions;

export const populatePortfolios = portfolios => {
  return dispatch => {
    dispatch(setPortfolios(portfolios));
  };
};